<template>
  <div>
    <base-header class="pb-6 bg-pulse-blue">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Weekly Scoreboard</h6>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <div class="text-center">
            <img src="/img/pulse/pulse-logo-black.png" class="mb-3" style="width: 150px; height: auto">
            <h3>Weekly Scoreboard</h3>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row class="text-center">
            <b-col>
              <h2><small><i class="fas fa-caret-left mr-2" @click="prevWeek"></i></small> {{ new Date(start_date) | date('MM/dd/yyy') }} - {{ new Date(end_date) | date('MM/dd/yyy') }} <small><i class="fas fa-caret-right ml-2" @click="nextWeek"></i></small></h2>
            </b-col>
          </b-row>
        </b-card-body>
        <loading-panel v-if="scores.length == 0"></loading-panel>
        <div v-else>
          <b-table responsive small :items="scores" :fields="fields">
            <template #cell(section)="row">
              <strong>{{ row.item.section }}</strong>
            </template>

            <template #cell(weekly_total)="row">
              <span v-if="row.item.section !== 'Date'">
                <span v-if="['Closed Volume', 'Paid GCI'].includes(row.item.section)">{{ rowSum(row.item) | currency }}</span>
                <span v-else>{{ rowSum(row.item) }}</span>
              </span>
            </template>

            <template #cell(weekly_goal)="row">
              <span v-if="row.item.section == 'Conversations'">{{ (conversations / 46).toFixed(2) }}</span>
              <span v-if="row.item.section == 'Appointments Held'">{{ (appointments / 46).toFixed(2) }}</span>
              <span v-if="row.item.section == 'Signed Agreements'">{{ (agreements / 46).toFixed(2) }}</span>
              <span v-if="row.item.section == 'Closed Units'">{{ (units / 46).toFixed(2) }}</span>
              <span v-if="row.item.section == 'Closed Volume'">{{ volume / 46 | currency }}</span>
              <span v-if="row.item.section == 'Paid GCI'">{{ goals.gci / 46 | currency }}</span>
              <span v-if="row.item.section == 'Ambassadors Added'">{{ (ambassadors / 46).toFixed(2) }}</span>
            </template>

            <template #cell()="row">
              <span v-if="row.item.section == 'Date'">
                {{ new Date(row.item[row.field.key]) | date('MM/dd') }}
              </span>
              <span v-else>
                {{ row.item[row.field.key] }}
              </span>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  components: {
    LoadingPanel
  },
  data() {
    return {
      year: new Date().getFullYear(),
      start_date: null,
      end_date: null,
      scores: [],
      fields: [
        { key: 'section', label: '' },
        { key: 'mon', tdClass: 'px-1' },
        { key: 'tues', tdClass: 'px-1' },
        { key: 'wed', tdClass: 'px-1' },
        { key: 'thurs', tdClass: 'px-1' },
        { key: 'fri', tdClass: 'px-1' },
        { key: 'sat', tdClass: 'px-1' },
        { key: 'sun', tdClass: 'px-1' },
        { key: 'weekly_total', tdClass: 'text-center align-middle' },
        { key: 'weekly_goal', tdClass: 'text-center align-middle' }
      ],
      goals: {
        gci: 0,
        avg_sale_price: 0,
        avg_commission_percent: 0,
      }
    }
  },
  computed: {
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    commission() {
      return this.goals.avg_sale_price * (this.goals.avg_commission_percent / 100);
    },
    units() {
      return this.commission > 0 ? Math.round(this.goals.gci / this.commission) : 0;
    },
    conversations() {
      return 200 * this.units;
    },
    appointments() {
      return 4 * this.units;
    },
    agreements() {
      return 2 * this.units;
    },
    ambassadors() {
      return 6 * this.units;
    },
    volume() {
      return this.goals.avg_sale_price * this.units;
    }
  },
  methods: {
    async getWeeklyScores(startDate = null, endDate = null) {
      await axios.get(this.userRoute + "/pulse/scores?start_date=" + startDate + "&end_date=" + endDate)
      .then(response => {
        this.start_date = response.data.start_date;
        this.end_date = response.data.end_date;
        this.scores = response.data.scores;
      })
      .catch(error => {
        // 
      });
    },
    async getAnnualGoals() {
      await axios.get(this.userRoute + "/pulse/pulse-annual-goals?year=" + this.year)
      .then(response => {
        if (response.data.id) {
          this.goals = response.data;
        }
      })
      .catch(error => {
        // 
      });
    },
    prevWeek() {
      var startDate = new Date(this.start_date);
      var endDate = new Date(this.end_date);
      this.start_date = startDate.setDate(startDate.getDate() - 7);
      this.end_date = endDate.setDate(endDate.getDate() - 7);

      this.getWeeklyScores(new Date(this.start_date).toLocaleDateString("en-US"), new Date(this.end_date).toLocaleDateString("en-US"));
    },
    nextWeek() {
      var startDate = new Date(this.start_date);
      var endDate = new Date(this.end_date);
      this.start_date = startDate.setDate(startDate.getDate() + 7);
      this.end_date = endDate.setDate(endDate.getDate() + 7);

      this.getWeeklyScores(new Date(this.start_date).toLocaleDateString("en-US"), new Date(this.end_date).toLocaleDateString("en-US"));
    },
    rowSum(row) {
      let items = {...row};
      delete items.section;

      return Object.values(items).reduce((total, item) => {
        return total + Number(item);
      }, 0);
    },
    async submit() {
      await axios.post(this.userRoute + "/pulse/scores", this.scores)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        // 
      });
    }
  },
  mounted() {
    document.title = 'Pulse Weekly Scoreboard | ClarityNOW';
  },
  created() {
    this.getWeeklyScores();
    this.getAnnualGoals();
  }
};
</script>
<style lang="scss">
.input-group-sm > .input-group-prepend > .input-group-text {
  padding: 0.15rem 0.5rem;
}
.bg-pulse-blue {
  background-color: #262262!important;
}
.pulse-btn  {
  background-color: #DDB143!important;
  border-color: #DDB143!important;
}
</style>